import React from "react";

import { Switcher } from "@moai/core";
import { useStorage } from "../../storage/use-storage";
import { SetState } from "../../types/types";

export type Theme = string;
export type SetTheme = React.Dispatch<React.SetStateAction<Theme>>;

export const themeOptions = [
    { label: "Light", value: "theme-light" },
    { label: "Dark", value: "theme-dark" },
    { label: "System", value: "theme-auto" },
];

const html = document.documentElement;

export const useTheme = () => {
    const [value, setValue] = useStorage("pref-theme", "theme-auto");

    React.useEffect(() => {
        html.classList.add(value);
        return () => html.classList.remove(value);
    }, [value]);

    return { theme: value, setTheme: setValue };
};

interface Props {
    theme: string;
    setTheme: SetState<string>;
}

export const ThemeSelect: React.FC<Props> = ({ theme, setTheme }) => (
    <Switcher value={theme} setValue={setTheme} options={themeOptions} />
);
